import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { User } from 'src/app/beans/login/user/user.bean';
import { Site } from 'src/app/beans/site/site.bean';
import { SlotModelAuto } from 'src/app/beans/slot-model/slot-model.auto.bean';
import { OrganizationSelect } from 'src/app/components/select/organization/organization-select/organization.select';
import { SiteSelect } from 'src/app/components/select/site/site-select/site.select';
import { addIdsToArray, CustomButton, CustomColumn, CustomTableComponent } from 'src/app/components/table/custom-table/custom-table.component';
import { SlotAutomateDialog } from 'src/app/dialogs/slot-automate/slot.automate.dialog';
import { DialogsReturnCode } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { PipeManager } from 'src/app/managers/pipe/pipe.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { Router } from '@angular/router';
import { RoutingPages } from 'src/app/enums/routing/routing-pages.enum';
import { ModelApplyDialog } from 'src/app/dialogs/slot-model-apply/slot.model.apply.dialog';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';

@Component({
  selector: 'slot.automate.page',
  templateUrl: './slot.automate.page.html',
  styleUrls: ['./slot.automate.page.scss']
})
export class SlotAutomatePage implements OnInit {

  orgSelect: OrganizationSelect
  @ViewChild('orgManager') set _orgSelect(orgSelect: OrganizationSelect){
    if (orgSelect){
      this.orgSelect = orgSelect
    }
  }
  site: Site
  @ViewChild('siteManager') set _siteSelect(siteSelect: SiteSelect){
    if (siteSelect){
      this.site = siteSelect.getSelectedValue()
      this.init()
    }
  }

  @ViewChild('slotAutomateTable') slotAutomateTable: CustomTableComponent




  slotautomateColumns: CustomColumn [] = [
    {
      isId   : true,
      label  : "id",
      name   : "id",
      display: ( val : any ) => false ,
    },
    {
      label: "serviceName",
      name : "tables.slotautomate.labels.service"
    },
    {
      label: "modelName",
      name : "tables.slotautomate.labels.model"
    },
    {
      label: "lastDate",
      name : "tables.slotautomate.labels.insertdate",
      pipe : (lastDate: any) => lastDate ? this._utils.date().toFormat(lastDate, "dd-MM-yyyy") : null
  
    },
    {
      label: "dayAdvance",
      name : "tables.slotautomate.labels.advance"
    },
    {
      label: "dayAdd",
      name : "tables.slotautomate.labels.add"
    },
    {
      label: "holiday",
      name : "tables.slotautomate.labels.holiday",
      pipe : (holiday: any) => this._pipe.tables().is_assigned(holiday),
    },
    {
      label: "enabled",
      name : "tables.slotautomate.labels.enabled",
      pipe : (enabled: any) => this._pipe.tables().is_enabled(enabled),
    },
  ]

  buttons: CustomButton[] = [
    {
      label : "modify",
      column: "tables.slotautomate.labels.action",
      name  : "tables.slotautomate.labels.modify",
      action: async (item: any) => { 
        await this.update(item)
      }
    }
  ]


  constructor
  (
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
    private _dialog : MatDialog     ,
    private _pipe   : PipeManager   ,
    private _router : Router,
    private _utils : UtilsManager
  ) {}

  values   : any[] = []

  ngOnInit(): void {
  }

  //-------------------------------------------------------------------------------------------

  siteChange(site:Site){
    this.site = site;
    this.init()
  }

  //-------------------------------------------------------------------------------------------


  async update(item: any)
  {    
    this.openDialog( "update", item )
  }

  async openDialog( action: string, slotModelAuto: SlotModelAuto )
  {
    const dialogConfig = new MatDialogConfig();
    

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = true;

    let dialog: any

    dialogConfig.data = {
      serviceId   : slotModelAuto.serviceId,
      serviceName : slotModelAuto.serviceName,
      modelId     : slotModelAuto.modelId  ,
      modelName   : slotModelAuto.modelName,
      dayAdvance  : slotModelAuto.dayAdvance,
      dayAdd      : slotModelAuto.dayAdd,
      holiday     : slotModelAuto.holiday,
      lastDate    : slotModelAuto.lastDate,
      enabled     : slotModelAuto.enabled,
      siteId      : this.site.id
    }

    
    if( action )
    {
      dialog = this._dialog.open(SlotAutomateDialog, dialogConfig);
    }
    else return

    dialog.afterClosed().subscribe(async (data: any) =>
    {

      //Refresh table data
      if (data.code == DialogsReturnCode.SLOTMODEL_AUTO)
      {
        this.values = await this.retriveValues( this.site.id )
        this.values = addIdsToArray(this.values)
      }
    })
  }

  //-------------------------------------------------------------------------------------------

  async init() 
  {
    if ( this.site ) 
    {
      this.values = await this.retriveValues( this.site.id );   
      this.values = addIdsToArray(this.values)   
    }
  }

  //-------------------------------------------------------------------------------------------

  async retriveValues( siteId: number ) 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()
    this.slotAutomateTable.reloadData()

    let response = null

    response = await this._handler.slotModel().listAuto((user as User).token, siteId)

    
    this._loader.stop()
    this.slotAutomateTable.dataLoaded()

    if ( !response      ) return
    if ( !response.list ) return

    return response.list as SlotModelAuto[];
  }

  gotoModels()
  {
    const route = "/" + RoutingPages.SLOTMODEL;
    this._session.menu().set( {
      item: {
        id: RoutingPages.SLOTMODEL,
        ref: RoutingPages.SLOTMODEL,
        title: RoutingPages.SLOTMODEL
      },
      opened: false
    } )

    this._router.navigate([route]);
  }

  applyModel()
  {
    const dialogConfig = new MatDialogConfig();
    

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = true;

    let dialog: any
    let services = []

    for(var i=0; i<this.values.length; i++)
    {
      let service = {
        id : this.values[i].serviceId,
        name : this.values[i].serviceName
      }

      services.push(service)
    }
     

    dialogConfig.data = {
      services : services,
      siteId      : this.site.id
    }

    dialog = this._dialog.open(ModelApplyDialog, dialogConfig);

    dialog.afterClosed().subscribe(async (data: any) =>
    {

      if(data.code != DialogsReturnCode.SLOTMODEL_MODEL) return
      
      const user = this._session.user().get()

      if (!User.isKind(user)) return
      
      this._loader.start()

      let response = null      

      response = await this._handler.slotModel().apply((user as User).token, data.param.dF, data.param.dT, data.param.s, data.param.m, data.param.h, data.param.d )

      console.log(response);
      
      this._loader.stop()
      
    })

  }

}
